import React from 'react';
import { useTheme, Theme, DialogTitle, IconButton, Icon } from '@mui/material';

interface ModalHeaderProps {
  className?: string;
  titleClassName?: string;
  closeClassName?: string;
  handleClose?: () => void;
  children: React.ReactNode;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ handleClose, children }) => {
  const theme: Theme = useTheme();

  const sxStyles = useSxStyles(theme);

  return (
    <span style={sxStyles.container}>
      <DialogTitle sx={sxStyles.title}>{children}</DialogTitle>

      {handleClose && (
        <IconButton sx={sxStyles.close} onClick={handleClose} aria-label='close'>
          <Icon>close</Icon>
        </IconButton>
      )}
    </span>
  );
};

export default ModalHeader;

const useSxStyles = (theme: Theme): any => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 1, 1, 2),
  },
  title: {
    padding: 0,
    margin: 0,
    lineHeight: 1.2,
    fontSize: '20px',
    fontWeight: 600,
  },
  close: {
    padding: theme.spacing(1),
    color: theme.palette.text.primary,
  },
});
